import { FC, useMemo } from "react";
import { BlogListItem } from "../../../types";
import styles from "./index.module.scss";
import CardImg from "../../course-list/card-img";
import dayjs from "dayjs";
import ClockIcon from "../../../icons/clock";
import cn from "classnames";

interface BlogCardProps {
  dataSource: BlogListItem;
  long?: boolean;
}

const BlogCard: FC<BlogCardProps> = ({ dataSource, long = false }) => {
  const pubTime = useMemo(() => {
    const { pub_time } = dataSource;
    return pub_time ? dayjs(pub_time).format("YYYY-MM-DD") : "-";
  }, [dataSource]);

  const goTocoursePage = () => {
    window.open(`//edu.py2fun.com/articles/${dataSource.id}`, "_blank");
  };

  const Info = () => {
    return (
      <div className={styles.info}>
        <div className={styles.time}>{pubTime}</div>
        <div className={styles.read}>
          <ClockIcon />约 {dataSource.read_time} 分钟
        </div>
      </div>
    );
  };

  return (
    <div
      className={cn(styles["blog-card"], long ? styles.long : "")}
      onClick={goTocoursePage}
    >
      <CardImg
        width={long ? "400px" : "100%"}
        height={long ? "200px" : undefined}
        src={dataSource.cover}
      />

      <div className={styles.content}>
        {!long && <Info />}
        <div className={styles.title}>{dataSource.title}</div>
        <div className={styles.summary}>{dataSource.summary}</div>
        {long && <Info />}
      </div>
    </div>
  );
};

export default BlogCard;
